import { Signer } from 'ethers'
import farmsConfig from 'config/constants/farms'
import {
  fetchFarmUserEarnings,
  fetchFarmUserEarningsV2,
  fetchFarmUserAllowances,
  fetchFarmUserTokenBalances,
  fetchFarmUserStakedBalances,
  fetchFarmUserStakedBalancesV2,
  fetchFarmUserPendingRewardsV2,
  fetchFarmUserPendingBoostRewards,
  fetchFarmUserPendingBoostRewardsAllFarms,
} from 'state/farms/fetchFarmUser'

export const fetchFarmsUser = async ({
  account,
  pids,
  signer,
}: {
  account: string
  pids: number[]
  signer: Signer
}) => {
  const farmsToFetch = farmsConfig.filter((farmConfig) => pids.includes(farmConfig.pid) && farmConfig.version === 1)
  const farmsToFetchV2 = farmsConfig.filter((farmConfig) => pids.includes(farmConfig.pid) && farmConfig.version === 2)

  const [
    userFarmAllowances,
    userFarmTokenBalances,
    userFarmStakedBalances,
    userFarmEarnings,

    userFarmAllowancesV2,
    userFarmTokenBalancesV2,
    userFarmStakedBalancesV2,
    userFarmEarningsV2,
    userFarmPendingRewardsV2,

    userFarmsPendingBoostRewardsV1,
    userFarmsPendingBoostRewardsV2,
    userFarmsPendingBoostRewardsAllFarms,
  ] = await Promise.all([
    fetchFarmUserAllowances(account, farmsToFetch),
    fetchFarmUserTokenBalances(account, farmsToFetch),
    fetchFarmUserStakedBalances(account, farmsToFetch),
    fetchFarmUserEarnings(account, farmsToFetch),

    fetchFarmUserAllowances(account, farmsToFetchV2),
    fetchFarmUserTokenBalances(account, farmsToFetchV2),
    fetchFarmUserStakedBalancesV2(account, farmsToFetchV2),
    fetchFarmUserEarningsV2(account, farmsToFetchV2),
    fetchFarmUserPendingRewardsV2(account, farmsToFetchV2),

    fetchFarmUserPendingBoostRewards(farmsToFetch, signer),
    fetchFarmUserPendingBoostRewards(farmsToFetchV2, signer),
    fetchFarmUserPendingBoostRewardsAllFarms(signer),
  ])

  const userDataV1 = userFarmAllowances.map((_: void, index: number) => {
    return {
      pid: farmsToFetch[index].pid,
      version: 1,
      allowance: userFarmAllowances[index],
      tokenBalance: userFarmTokenBalances[index],
      stakedBalance: userFarmStakedBalances[index],
      earnings: userFarmEarnings[index],
      boostRewards: userFarmsPendingBoostRewardsV1[index],
      boostRewardsAllFarms: userFarmsPendingBoostRewardsAllFarms,
    }
  })
  const userDataV2 = userFarmAllowancesV2.map((_: void, index: number) => {
    return {
      pid: farmsToFetchV2[index].pid,
      version: 2,
      allowance: userFarmAllowancesV2[index],
      tokenBalance: userFarmTokenBalancesV2[index],
      stakedBalance: userFarmStakedBalancesV2[index],
      earnings: userFarmEarningsV2[index],
      earningsV2: userFarmPendingRewardsV2[index],
      boostRewards: userFarmsPendingBoostRewardsV2[index],
      boostRewardsAllFarms: userFarmsPendingBoostRewardsAllFarms,
    }
  })

  return [...userDataV1, ...userDataV2]
}
